import { Box, Flex, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Modal from "src/components/Modal";
import { H3, Subtitle } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";
import IconOnBackgound from "src/components/IconOnBackground";

import { ReactComponent as SelectedIcon } from "./done.svg";
import { ReactComponent as SettingsIcon } from "./settings.svg";

function ListItem({ name, isSelected, onSelect, contentBeforeName }) {
  return (
    <Flex
      transition="background 300ms"
      _hover={{ bg: "rgba(0, 0, 0, 0.08)" }}
      onClick={onSelect}
      py="12px"
      px="24px"
      justifyContent="space-between"
      alignItems="center"
    >
      <Flex alignItems="center">
        {contentBeforeName && <Box mr="16px">{contentBeforeName}</Box>}
        <Subtitle
          color="highEmphasis"
          maxWidth="150px"
          overflow="hidden"
          white-space="nowrap"
          text-overflow="ellipsis"
        >
          {name}
        </Subtitle>
      </Flex>
      {isSelected && (
        <SvgContainer icon={SelectedIcon} fill="primary" size="20px" />
      )}
    </Flex>
  );
}

export default function ListSelect({
  isOpen,
  onClose,
  heading,
  onManage,
  manageButtonText,
  items,
  selectedItem,
  onSelect
}) {
  const { t } = useTranslation();
  return (
    <Modal contentStyles={{ paddingTop: "24px" }} isOpen={isOpen}>
      <Box
        width="280px"
        borderBottom="1px solid rgba(0, 0, 0, 0.2)"
        maxHeight="400px"
        overflowY="auto"
      >
        <H3 color="highEmphasis" px="24px" my="12px">
          {heading}
        </H3>
        <ListItem
          key={selectedItem.id}
          isSelected={true}
          name={selectedItem.name}
          contentBeforeName={selectedItem.contentBeforeName}
        />
        {items.map((item) => (
          <ListItem
            key={item.id}
            isSelected={false}
            onSelect={() => onSelect(item.id)}
            name={item.name}
            contentBeforeName={item.contentBeforeName}
          />
        ))}
        {onManage && (
          <Flex
            onClick={onManage}
            alignItems="center"
            py="12px"
            px="24px"
            transition="background 300ms"
            _hover={{ bg: "rgba(0, 0, 0, 0.08)" }}
          >
            <IconOnBackgound
              mr="16px"
              icon={SettingsIcon}
              fill="mediumEmphasis"
              bg="black8"
              iconSize="20px"
              size="32px"
            />
            <Subtitle color="highEmphasis">{manageButtonText}</Subtitle>
          </Flex>
        )}
      </Box>
      <Flex justifyContent="center" py="4px">
        <Button variant="flatPrimary" onClick={onClose}>
          {t("buttons.cancel")}
        </Button>
      </Flex>
    </Modal>
  );
}
